import React from 'react';
import { Button } from '../../components/ui/button';
import { Loader2, Download, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_findmed-app/artifacts/ge9othd8_LOGO%20SOS%20FINDMED.png";

const statusLabel = { active: 'ACTIVA', pending: 'PENDIENTE', consumed: 'CONSUMIDA', cancelled: 'CANCELADA', expired: 'EXPIRADA' };
const statusColor = { active: '#22C55E', pending: '#EAB308', consumed: '#EF4444', cancelled: '#6B7280', expired: '#6B7280' };

export const DigitalCard = ({ cardRef, m, profile, user, downloading, downloadCard }) => {
  return (
    <>
      <div ref={cardRef} className="p-5" style={{ background: '#0D0D0D' }}>
        <div
          className="relative overflow-hidden rounded-3xl p-7"
          style={{
            background: 'linear-gradient(145deg, #C81D25 0%, #8B0000 40%, #4A0000 100%)',
            boxShadow: '0 25px 60px rgba(200, 29, 37, 0.4), 0 0 100px rgba(200, 29, 37, 0.08)'
          }}
          data-testid="digital-card"
        >
          <div className="absolute top-0 right-0 w-52 h-52 opacity-20"
            style={{ background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%)', transform: 'translate(30%, -30%)' }} />
          <div className="absolute bottom-0 left-0 w-40 h-40 opacity-15"
            style={{ background: 'radial-gradient(circle, rgba(255,215,0,0.1) 0%, transparent 70%)', transform: 'translate(-30%, 30%)' }} />

          <div className="flex items-start justify-between mb-6 relative z-10">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="SOS FindMed" className="w-36 h-auto object-contain" style={{ filter: 'drop-shadow(0 0 6px rgba(255,255,255,0.95)) drop-shadow(0 0 12px rgba(255,255,255,0.5))' }} />
            </div>
            <span className="px-4 py-1.5 rounded-full text-[10px] font-extrabold tracking-widest uppercase"
              style={{ background: statusColor[m.status] || '#6B7280', color: m.status === 'pending' ? '#000' : '#FFF' }}>
              {statusLabel[m.status] || 'EXPIRADA'}
            </span>
          </div>

          <div className="w-12 h-9 rounded-md mb-6 relative z-10"
            style={{ background: 'linear-gradient(135deg, #FFD700 0%, #B8860B 50%, #FFD700 100%)', boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)' }} />

          <div className="mb-6 relative z-10">
            <p className="text-white/40 text-[10px] tracking-[3px] uppercase mb-1">Numero de Membresia</p>
            <p className="text-white text-2xl font-bold tracking-[4px] font-mono" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>{m.card_code}</p>
          </div>

          <div className="mb-6 relative z-10">
            <p className="text-white/40 text-[10px] tracking-[3px] uppercase mb-1">Beneficiario</p>
            <p className="text-white text-lg font-semibold uppercase tracking-wide">{m.beneficiary_name || profile?.name || user?.name}</p>
          </div>

          <div className="h-px my-5 relative z-10" style={{ background: 'linear-gradient(90deg, transparent, rgba(255,215,0,0.3), transparent)' }} />

          <div className="flex items-end justify-between relative z-10">
            <div>
              <p className="text-white/40 text-[9px] tracking-[2px] uppercase mb-1">Vigencia</p>
              <p className="text-white text-sm font-medium">{m.expiry_date ? new Date(m.expiry_date).toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' }) : 'N/A'}</p>
            </div>
            <div className="text-right">
              <p className="text-white/40 text-[9px] tracking-[2px] uppercase mb-1">Emergencias 24/7</p>
              <p className="text-lg font-extrabold" style={{ color: '#FFD700', textShadow: '0 0 20px rgba(255,215,0,0.5)' }}>55 2567 1884</p>
            </div>
          </div>

          <div className="absolute bottom-3 right-5 opacity-[0.08] z-0">
            <img src={LOGO_URL} alt="" className="w-32 h-auto object-contain" style={{ filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.6))' }} />
          </div>
        </div>
      </div>

      <div className="flex gap-3 px-1">
        <Button onClick={downloadCard} disabled={downloading}
          className="flex-1 bg-white/10 hover:bg-white/20 text-white border border-white/10 py-5" data-testid="download-card-btn">
          {downloading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}
          Descargar Tarjeta
        </Button>
        <a href="tel:5525671884" className="flex-1">
          <Button className="w-full bg-[#C81D25] hover:bg-[#A6141B] text-white py-5" data-testid="call-emergency-btn">
            <Phone className="w-4 h-4 mr-2" />Llamar Emergencias
          </Button>
        </a>
      </div>
    </>
  );
};
